// extracted by mini-css-extract-plugin
export default {"root":"kucL6jE03t4kOsdcuFfQ"};